import {
  Field,
  FieldLabel,
  Input,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui";
import { Select } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import { AllergyIntolerance } from "@curai/js-fhir-tools";
import { type LucideIcon, Trash2 } from "lucide-react";

const SEVERITY_OPTIONS = Object.values(
  AllergyIntolerance.ReactionEventSeverity,
);
const SEVERITY_NONE = "_none";

interface ReactionRowProps {
  index: number;
  severity: string | undefined;
  description: string | undefined;
  onSeverityChange: (val: string) => void;
  onDescriptionChange: (val: string) => void;
  onRemove: () => void;
  actionIcon?: LucideIcon;
  actionAriaLabel?: string;
  showAction?: boolean;
}

export const ReactionRow = ({
  index,
  severity,
  description,
  onSeverityChange,
  onDescriptionChange,
  onRemove,
  actionIcon: ActionIcon = Trash2,
  actionAriaLabel = "Remove reaction",
  showAction = true,
}: ReactionRowProps) => {
  return (
    <div className="flex flex-row gap-1 items-end">
      <Field className="flex flex-col w-[96px] flex-shrink-0">
        {index === 0 && <FieldLabel>Severity</FieldLabel>}
        <Select
          value={severity || SEVERITY_NONE}
          onValueChange={(val) =>
            onSeverityChange(val === SEVERITY_NONE ? "" : val)
          }
        >
          <SelectTrigger className={!severity ? "text-tertiary" : undefined}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={SEVERITY_NONE} className="text-tertiary">
              Unknown
            </SelectItem>
            {SEVERITY_OPTIONS.map((sev) => (
              <SelectItem key={sev} value={sev}>
                {AllergyIntolerance.ReactionEventSeverityDisplay[sev]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Field>
      <Field className="flex flex-col flex-1 min-w-0">
        {index === 0 && <FieldLabel>Symptoms</FieldLabel>}
        <Input
          value={description ?? ""}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Enter symptoms"
        />
      </Field>
      {showAction && (
        <Button
          type="button"
          variant="icon"
          size="xs"
          onClick={onRemove}
          className="mb-1 text-tertiary hover:text-error transition-colors flex-shrink-0"
          aria-label={actionAriaLabel}
        >
          <ActionIcon size={16} />
        </Button>
      )}
    </div>
  );
};
